var HashDialogView = require('hashdialogview');
var Keyboard = require('../lib/keyboard.es6').default;


var ShortcutsDialogView = HashDialogView.extend({
    el: '#shortcutsOverlayContents',
    wrapper: $('#shortcutsContainer'),
    events: $.extend({}, HashDialogView.prototype.events, {
        'click .prefModifierMe__toggle': 'togglePrefModifierMe'
    }),
    initialize: function (options) {
        HashDialogView.prototype.initialize.call(this, options);

        this.router.route('?/shortcuts', 'show', _.bind(this.show, this));

        $(window).on('keydown', _.bind(function (e) {
            if (Keyboard.isModifier(e) && e.which === Keyboard.KEYS['/']) {
                e.preventDefault();
                this.model.trigger('navigate', '?/shortcuts', {trigger: true});
            }
        }, this));

        this.renderModifierMe();
        this.listenTo(this.model, 'prefChange:keyboard-disable-modifier-me', this.renderModifierMe);
    },
    renderModifierMe: function () {
        var shortcut = this.$('.prefModifierMe__shortcut');
        var enabled = this.model.modifierMeEnabled();
        shortcut.toggleClass('prefModifierMe__shortcut--disabled', !enabled);
        shortcut.toggleClass('prefModifierMe__shortcut--enabled', enabled);
    },
    togglePrefModifierMe: function (e) {
        e.preventDefault();
        this.model.setModifierMe(!this.model.modifierMeEnabled());
    }
});


module.exports = ShortcutsDialogView;



//////////////////
// WEBPACK FOOTER
// ./app/src/view/shortcutsdialogview.js
// module id = UwCA
// module chunks = 1